import React from 'react'
import styled from 'styled-components'
import { auth, provider } from '../firebase'


function Login(props) {

    const signIn = () => {
        auth.signInWithPopup(provider)
        .then((result)=>{

            const newUser = {
                name: result.user.displayName,
                photo: result.user.photoURL,
            }
            localStorage.setItem('user', JSON.stringify(newUser));
            props.setUser(newUser);
        })  

        .catch((error)=> {
            alert(error.message)
        })

    }
    return (
  
        <Container>
           
           <Content>
               <SlackImg src="https://images-platform.99static.com//S1Ky2NtDVQVxbCDHJuQzDhB_kJU=/99x35:678x614/fit-in/500x500/99designs-contests-attachments/100/100947/attachment_100947757"/>
               <h1>Sign in!</h1>
               <SignInButton onClick={()=>signIn()}>
                   Sign-in with Google
               </SignInButton>

           </Content>
           

        </Container>
    
    )
}

export default Login

const Container = styled.div
`
width:100%;
height:100vh;
background-color: #f8f8f8;
display:flex;
justify-content: center;
align-items: center;
background-image: linear-gradient(#FD297A , #9424F0);
`
const Content = styled.div
`
background: white;
padding:100px;
border-radius:10%;
box-shadow: 0 1px 3px rgba(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;


`
const SlackImg = styled.img
`
height: 160px;

`

const SignInButton = styled.button
`
margin-top:50px;
background: #9424F0;
color: white;
font-weight: bold;
bordeer:none;
height:40px;
border-radius:10px;
cursor:pointer;
font-size:17px;


`